import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LinkGroupHeading from './styled/LinkGroupHeading';
import LinkGroupWrapper from './styled/LinkGroupWrapper';
import { Desktop } from '../../MediaQuery';
import LinkGroupTitle from './LinkGroupTitle';
import LinkGroupList from './LinkGroupList';

class LinkGroup extends Component {
  constructor(props) {
    super(props);
    this.toggleSection = this.toggleSection.bind(this);
    this.state = {};
  }

  toggleSection(index) {
    const showSection = this.state[`showSection${index}`];
    this.setState({ [`showSection${index}`]: !showSection });
  }

  render() {
    const { s3BasePath, linkData, socialComp } = this.props;

    return (
      <LinkGroupWrapper>
        {linkData.map(({ links, title, code }, index) => (
          <div key={title}>
            <LinkGroupTitle
              index={index}
              title={title}
              s3BasePath={s3BasePath}
              showSection={this.state[`showSection${index}`]}
              toggleSection={this.toggleSection}
            />
            <LinkGroupList showSection={this.state[`showSection${index}`]} links={links} code={code} />
          </div>
        ))}
        <Desktop>
          <div style={{ flex: 0.5, paddingLeft: '40px' }}>
            <LinkGroupHeading style={{ marginLeft: '5px' }}>Follow Us</LinkGroupHeading>
            <div>{socialComp}</div>
          </div>
        </Desktop>
      </LinkGroupWrapper>
    );
  }
}

LinkGroup.propTypes = {
  linkData: PropTypes.arrayOf(
    PropTypes.shape({
      links: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string, link: PropTypes.string })).isRequired,
      title: PropTypes.string,
      code: PropTypes.string.isRequired
    })
  ).isRequired,
  s3BasePath: PropTypes.string.isRequired
};

export default LinkGroup;
